export class UserProFileModel {

    userId: number = 0
    titId: number = 0
    titText: string = null!
    userName: string = null!
    userSurname: string = null!
    idNo: string = null!
    natId: number = 0
    natText: string = null!
    ethId: number = 0
    ethText: string = null!
   // birthDate: Date = null!
    birthDate: string = null!
    mobilePhone: string = null!
    careerId: number = 0
    careerText: string = null!
    passportNo: string = null!
    workPermit: string = null!
    // ethText: string = null!
    // natText: string = null!
    acC_NO_H: string = null!
    acC_MOO_H: string = null!
    acC_SOI_H: string = null!
    acC_ROAD_H: string = null! 
    taM_TEXT_H: string = null!
    
    amP_TEXT_H: string = null!
    proV_TEXT_H: string = null!
    acC_POSTCODE_H: string = null!
}

export class UserEmailModel {
    email: string = null!
    emailCensor: string = null!
    emailSecondary: string = null!
    emailSecondaryCensor: string = null!
}

export class UserAddressModel {
    userId: number = 0
    acC_NO_H: string = null!
    acC_MOO_H: string = null!
    acC_SOI_H: string = null!
    acC_ROAD_H: string = null!
    taM_ID_H: number = 0
    amP_ID_H: number = 0
    proV_ID_H: number = 0
    acC_POSTCODE_H: string = null!
    acC_TEL_H: string = null!
    acC_FAX_H: string = null!
    countrY_ID_H: number = 0
    adD_FOREIGN_H: string = null!
    taM_TEXT_H: string = null!
    amP_TEXT_H: string = null!
    proV_TEXT_H: string = null!
    countrY_TEXT_H: string = null!
    acC_NO_C: string = null!
    acC_MOO_C: string = null!
    acC_SOI_C: string = null!
    acC_ROAD_C: string = null!
    taM_ID_C: number = 0
    amP_ID_C: number = 0
    proV_ID_C: number = 0
    acC_POSTCODE_C: string = null!
    acC_TEL_C: string = null!
    acC_FAX_C: string = null!
    countrY_ID_C: number = 0
    adD_FOREIGN_C: string = null!
    taM_TEXT_C: string = null!
    amP_TEXT_C: string = null!
    proV_TEXT_C: string = null!
    countrY_TEXT_C: string = null!
}

export class userMobileModel {
    mobile: string = null!
}

export class snedMobileOtpModel {
    mobile: string = null!
    otp: string = null!
    refOTP: string = null!
}

export class userInfoModel {
    userName: string = null!
    userSurname: string = null!
    idNo: string = null!
    laserCode: string = null!
    birthDate: string = null!
    //birthDate: Date = new Date
    //laserCode: string = null!
}

export class userLoginModel {
    userId: number = 0
    userLogin: string = null!
}


export class UserProFileDetailSaveModel {

    titleId: number = null!
    ethId: number = null!
    natId: number = null!
    careerId: number = null!
    passportNo: string = null!
    workPermit: string = null!
    password: string = null!
}

export class savePasswordModel{
    passwordNew: string = null!
    passwordConfirm: string = null!
    passwordOld: string = null!
}

export class checkPasswordModel{
    isPassword : boolean = null!
}

export class checkUserLoginModel{
    isCanUser : boolean = null!
}

export class saveEmailModel{
    email: string = null!
    password: string = null!
    otpCode: string = null!
}

export class getInfoThaid {
    pid: string = null!
    given_name: string = null!
    family_name: string = null!
    birthdate: string = null!
}
